<script setup>
import { Link, useForm } from "@inertiajs/inertia-vue3";
import InputText from "primevue/inputtext";
import Button from "primevue/button";
import Checkbox from "primevue/checkbox";
import RadioButton from "primevue/radiobutton";
import InlineMessage from "primevue/inlinemessage";
import { ref } from "vue";

const emits = defineEmits(["next"]);
const props = defineProps([
    "form",
    "errors",
    'max2HoursOptions',
    "v$",
]);
const programs = ref([
    {
        label: "Muskelaufbau",
        value: "muscle_building",
        description:
            "Erhöhe dein Muskelvolumen und deine Muskelkraft und reduziere gleichzeitig Körperfett für eine sichtbare Körperstraffung und ein schöneres Erscheinungsbild.",
    },
    {
        label: "Lokale Fettpolster",
        value: "local_fat_deposits",
        description:
            "Lass deine hartnäckigen lokalen Fettdepots an Bauch, Hüfte, Gesäss oder Oberschenkel reduzieren.",
    },
    {
        label: "Übergewicht",
        value: "overweight",
        description:
            "Erreiche dein Wunschgewicht auf eine gesunde Weise, ohne an wichtiger Muskelmasse zu verlieren.",
    },
    {
        label: "Longevity",
        value: "longevity",
        description:
            "Senke mit uns dein biologisches Alter, verjünge dich, steigere dein Wohlbefinden und deine Leistungsfähigkeit.",
    },
    {
        label: "Cellulite",
        value: "cellulite",
        description:
            "Die Haut wird jugendlicher, straffer, elastischer und strahlender und die Cellulite wird sichtbar reduziert.",
    },
    {
        label: "Inkontinenz",
        value: "incontinence",
        description:
            "Gewinne mehr Lebensqualität durch Stimulation und Stärkung der Beckenboden-Muskulatur in nur 8 Behandlungen.",
    },
    {
        label: "Stress",
        value: "stress",
        description:
            "Nutze unser Hypoxie-Training, Kohlendioxid-Behandlungen, Infrarot und Negativionen um deinen Stress abzubauen und die Regulationsfähigkeit des Nervensystems zu verbessern.",
    },
    {
        label: "Müdigkeit",
        value: "tiredness",
        description:
            "Steigere mit Vigory deine Vitalität und deine Leistungsfähigkeit. Wir bringen dich wieder auf Kurs!",
    },
    {
        label: "Fitness-Training",
        value: "fitness_training",
        description:
            "Im VIGORY-Fitness kannst du bei uns auch einfach nur trainieren, ganz ohne die Beschwerlichkeit traditioneller Trainingsmethoden.",
    },
]);
</script>
<template>
    <div class="lato p-7 rounded my-2">
        <div class="mb-7">
            <div class="px-2 flex items-center gap-4 text-xl font-semibold">
                <div>Wähle dein(e) Programm(e) aus</div>
            </div>

            <div v-if="v$.form.programs.$error" class="px-2 text-sm text-[#dc2626]">
                {{ v$.form.programs.$errors[0].$message }}
            </div>
        </div>

        <div
            v-for="(item, i) in programs"
            :key="i"
            class="grid grid-cols-3 gap-4 my-5"
        >
            <div class="flex items-start gap-2">
                <Checkbox
                    :invalid="v$.form.programs.$error"
                    :value="item.value"
                    v-model="form.programs"
                    variant="filled"
                    class="mx-2 pt-[1px]"
                    @change="v$.form.programs.$touch"
                />

                <label class="">{{ item.label }}</label>
            </div>

            <div class="col-span-2">
                <div>
                    {{ item.description }}
                </div>
            </div>
        </div>

        <div class="max-w-3xl mx-auto mt-16">
            <div class="font-bold">
                Wie viele Trainings-/Therapieeinheiten à 2 Std. wären für dich
                pro Woche maximal möglich?
            </div>

            <div class="grid grid-cols-4 gap-4 my-5">
                <div class="" v-for="(item, i) in max2HoursOptions" :key="i">
                    <div class="flex items-center gap-4">
                        <RadioButton
                            :invalid="v$.form.max_two_hours_per_week.$error"
                            :value="item.value"
                            v-model="form.max_two_hours_per_week"
                        />
                        <div class="">{{ item.label }}</div>
                    </div>
                </div>
            </div>

            <div v-if="v$.form.max_two_hours_per_week.$error" class="text-sm text-[#dc2626]">
                {{ v$.form.max_two_hours_per_week.$errors[0].$message }}
            </div>
        </div>

        <div class="flex mt-10 justify-end">
            <Button
                label="weiter"
                class="min-w-[100px] !bg-black !text-[#FFF053] !border-none"
                @click="emits('next', 'goals', 'program')"
            />
        </div>
    </div>
</template>
